import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
  } from "@mui/material";
  import { useTranslation } from "react-i18next";
  import { makeStyles } from "@mui/styles";
  import React, { useEffect } from "react";
  import {ReactComponent as DialogCheck} from "../assets/images/dialog-alert.svg";
const useStyles = makeStyles({
    colorButton: {
        color: "red",
    }
});
const styles = {
containerDialog: {
    padding: "56px 24px 42px 24px"
    }
}
  const AlertSizeFile = (props) => {
    const handleClose = () => {
      props.setValue(false)
    };
    const classes = useStyles();
    return (
      <React.Fragment>
         <Dialog
onBackdropClick={() => {return false}}
          open={props.open}
          onClose={handleClose}
          maxWidth="xs"
          fullWidth={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent style={styles.containerDialog}>
            <DialogContentText id="alert-dialog-description" style={{display: 'flex', alignItems:'center', justifyContent: 'center', flexFlow: 'column'}}>
              <DialogCheck></DialogCheck>
              <Typography color="#CC6058" variant="h3" mt={3}>อัพโหลดไฟล์ไม่สำเร็จ</Typography>
              <Typography sx={{maxWidth: "233px"}} textAlign="center" mt={2}>{props.text}</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{display: 'flex', alignItems:'center', justifyContent: 'center', marginBottom: 56}}>
            <Button onClick={handleClose} size="large" variant="contained" sx={{width: '300px',color: "#fff!important", backgroundColor: '#CC6058', fontSize: '18px', lineHeight: '19.8px', paddingTop: '18px',paddingBottom: '18px'}} color="red">ลองอีกครั้ง</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };
  export default AlertSizeFile;